import React from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import { DlUnit } from "model/dl_unit/DlUnit";

type UnitEditNavProps = {
  unit: DlUnit;
};

const UnitEditNav = ({ unit }: UnitEditNavProps) => {
  const unitId = unit.id;

  return (
    <DivEditNav>
      <AppLink to={`/admin-dashboard/dl-unit-edit/${unitId}`}>polja</AppLink>
      {!unit.isTypeHM2() ? (
        <AppLink to={`/admin-dashboard/dl-unit-edit/${unitId}/scan`}>
          sken
        </AppLink>
      ) : (
        <AppLink to={`/admin-dashboard/dl-unit-edit/${unitId}/pdf`}>
          pdf
        </AppLink>
      )}
    </DivEditNav>
  );
};

export default UnitEditNav;

const DivEditNav = styled.div`
  display: flex;
  gap: 1rem;
`;
